import React from 'react'

const FilterIcon = ({ color }) => {
  return (
    <svg width='20' height='18' viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.6274 0.609375H1.37275C0.798531 0.609375 0.439937 1.23516 0.728218 1.73438L6.17978 11.0016V16.6406C6.17978 17.0555 6.51259 17.3906 6.92509 17.3906H13.0751C13.4876 17.3906 13.8204 17.0555 13.8204 16.6406V11.0016L19.2743 1.73438C19.5602 1.23516 19.2017 0.609375 18.6274 0.609375ZM12.1423 15.7031H7.85791V12.0469H12.1446V15.7031H12.1423ZM12.3673 10.1578L12.1446 10.5469H7.85556L7.63291 10.1578L2.98525 2.29688H17.0149L12.3673 10.1578Z'
        fill={color}
      />
    </svg>
  )
}

export default FilterIcon
